module.exports = __webpack_public_path__ + "media/stylesheets/images/trash-28939ecdfd6741b68d926d3184441c09.png";